import { render, staticRenderFns } from "./EditFeeCompanyComponent.vue?vue&type=template&id=c9c458b8&"
import script from "./EditFeeCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./EditFeeCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports